import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { UIinput } from '../uikit/UIinput';
import { UIbutton, MIcon } from '../uikit/Uikit';

export function MetadataAddTagForm({
  typeData,
  shownByDefault,
  time,
  handleTag,
  handleClose,
}) {

  const color = typeData['color'] || '#06a19a';

  return (
    <>
      <div className={`p_player_comment_add_form0 p_player_comment_add_form0--shown`}
        style={{
          zIndex: -1
        }}
      >
        <div className="p_player_comment_add_form">
          <div className="p_player_comment_add_form_bg"
            style={{ backgroundColor: typeData['color'] }}
          />


          <div className="p_player_comment_add_form_body">
            <div className="p_comment0 p_comment0--add">

              <div className="p_comment_time">
                <div className="p_comment_time0">
                  <img className="p_comment_time_frame" src="https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM.png" loading="lazy" sizes="44px" srcSet="https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM-p-500.png 500w, https://assets.website-files.com/61785133118e574036320746/617bb33ea5c8d3a0ec6393a2_Screen%20Shot%202021-10-29%20at%201.38.54%20AM.png 700w" alt />
                  <div className="p_comment_time_stamp">{time}</div>
                </div>
              </div>
              <div className="p_comment_right">
                <div className="p_comment">


                  <div className="p_comment_add0">

                    <div className="p_comment_add_form">
                      <div className="p_comment_add_textarea">
                        <UIinput
                          label={`Your comment at ${time}`}
                          style={{ width: '100%' }}
                        />
                      </div>
                      <div className="p_comment_add_submit">
                        <UIbutton
                          // sm
                          color={color}
                          onClick={() => handleTag()}
                        >Tag</UIbutton>&nbsp;&nbsp;

                        {handleClose && <UIbutton
                          // sm
                          flat
                          color={color}
                          onClick={() => handleClose()}
                        ><MIcon size={'lg'}>close</MIcon></UIbutton>}
                      </div>
                    </div>
                  </div>



                </div>
              </div>
            </div>



          </div>
        </div>
      </div>

    </>
  )
}

